import mergeOperations from "@/util/shallowMerge"
import {
  useMutation 
} from "@apollo/client"
import {
  useCallback, useMemo 
} from "react"
import DEFAULT_OPERATIONS from "./wholesaleProgramPage.gql"

export const useWholesaleProgramPage = (props) => {
  const operations = mergeOperations(DEFAULT_OPERATIONS)
  const {
    addWholesaleProgramMutation 
  } = operations
  const [
    addWholesaleProgram,
    {
      error: addWholesaleProgramError, loading: isSubmitting, data: data 
    },
  ] = useMutation(addWholesaleProgramMutation)

  const wholesaleProgramSubmit = useCallback(async (formValues) => {
    try {
      // if(!formValues.hasOwnProperty('itremark')){
      //     formValues.itremark='';
      // }
      // if(!formValues.hasOwnProperty('hkremark')){
      //     formValues.hkremark='';
      // }
      formValues.interested = formValues.interested.join(",")
      formValues.businesstype = formValues.businesstype.join(",")
      formValues.howknow = formValues.howknow.join(",")
      await addWholesaleProgram({
        variables: formValues,
      })
    } catch {
      // we have an onError link that logs errors, and FormError already renders this error, so just return
      // to avoid triggering the success callback
            
    }
  }, [])

  const errors = useMemo(
    () => new Map([
      [
        "addWholesaleProgramError",
        data?.addWholesaleProgram.message == "error"
          ? data.addWholesaleProgram.content
          : null,
      ],
    ]),
    [data]
  )

  return {
    errors,
    wholesaleProgramSubmit,
    isSubmitting,
    response: data && data.addWholesaleProgram,
  }
}
